var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":`I am currently looking for an opportunity`,"color":_vm.themes.candidate.light.input},on:{"change":_vm.submit},model:{value:(_vm.profile.currentlyLooking),callback:function ($$v) {_vm.$set(_vm.profile, "currentlyLooking", $$v)},expression:"profile.currentlyLooking"}})
}
var staticRenderFns = []

export { render, staticRenderFns }